module.exports = __webpack_public_path__ + "img/blue_triangle.1978a93.png";